/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const searchCrmObjectIdsEarlyRequestRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjectIds',
  auth: 'app',
  fingerprint: 'yflHfy_beMCAxVV_QbHNoq8QWJB5zcuN',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const searchCrmObjectsEarlyRequestRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjects',
  auth: 'app',
  fingerprint: 'QnRUnrkSBVnpOd6Y66VOUq8QWJB5zcuN',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};